<div class="panel panel-flat">
  <div class="content-group">
    <!--  <div class="page-header page-header-default">
      <div class="page-header-content">
        <div class="page-title">
          <h5>
            <i class="icon-list position-left"></i>
            <span class="text-semibold">Equb <span class="text-royal-400">{{ekub?.ekub_id}}</span></span>
          </h5>
        </div>
      </div>
    </div> -->

    <div class="tabbable">
      <ul class="nav nav-tabs nav-tabs-highlight">
        <li class="active"><a href="#members-tab" data-toggle="tab"> <i
              class="icon-people position-left"></i>Members</a>
        </li>
        <li><a href="#transactions-tab" data-toggle="tab"> <i class="icon-cash position-left"></i>Transactions</a>
        </li>
      </ul>

      <div class="tab-content">
        <div class="tab-pane active" id="members-tab">


          <div class="panel-body">

            <div class="row">
              <div class="col-md-9">

                <div class="row">
                  <div class="col-md-3 form-group required">
                    <span style="float:left" class="control-label">Filter by: </span>
                    <select name="status" required [(ngModel)]="filter" (ngModelChange)="getMembersFilter(filter)"
                      class="form-control">
                      <option selected disabled>Status</option>
                      <option value="">All</option>
                      <option value="&status=pending">Pending</option>
                      <option value="&status=active">Active</option>
                      <option value="&status=qualified">Qualified</option>
                      <option value="&status=disqualified">Disqualified</option>
                      <option value="&status=won">Won</option>
                    </select>
                  </div>
                  <div class="col-md-6 form-group">
                  </div>
                  <div class="col-md-3 form-group">
                    <span class="control-label">&nbsp; </span>
                    <div class="btn-group pull-right">
                      <a type="button" class="btn btn-icon btn-sm bg-slate-800 btn-rounded" data-toggle="modal"
                        data-target="#notificationModal">
                        <i class="icon-add position-left"></i> Broadcast Notification</a>
                      <!--  <a type="button" class="btn btn-icon btn-sm bg-slate-800 btn-rounded">
                        <i class="icon-printer position-left"></i>Print</a> -->
                    </div>

                  </div>
                </div>

                <table class="table datatable-column-search-inputs">
                  <thead>
                    <tr>
                      <th>Name</th>
                      <th>Rating</th>
                      <th>Email</th>
                      <th>Phone Number</th>
                      <th>Code</th>
                      <th>Enrolled</th>
                      <th>Membership Status</th>
                      <th class="text-center">Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      *ngFor="let user of ekubMembers | paginate: { id: 'ekubMembers',itemsPerPage: itemsPerPage,currentPage: currentPage,totalItems: totalItems }">
                      <td>
                        <div class="media">
                          <span class="media-left">
                            <img *ngIf="!user.avatar" src="assets/img/userm.png" width="40" height="40"
                              class="img-circle img-md" alt="">
                            <img *ngIf="user.avatar" [src]="baseUrl+'assets/'+user.avatar+'/render'" width="40"
                              height="40" class="img-circle img-md" alt="">
                          </span>
                          <div class="media-left">{{user.username}}
                            <div class="text-muted text-size-small">
                              {{user?.pivot?.branch?.name}} - {{user?.pivot?.branch?.city}}
                            </div>
                          </div>
                        </div>
                      </td>
                      <td>
                        <span *ngIf="user?.pivot.rating >=4"
                          class="label label-flat border-success text-success-600">{{user?.pivot.rating}}</span>
                        <span *ngIf="user?.pivot.rating >2.5 && user?.pivot.rating <4"
                          class="label label-flat border-warning text-warning-600">{{user?.pivot.rating}}</span>
                        <span *ngIf="user?.pivot.rating <= 2.5"
                          class="label label-flat border-danger text-danger-600">{{user?.pivot.rating}}</span>
                      </td>
                      <td>{{user.email}}</td>
                      <td>{{user.phone_number}}</td>
                      <td>{{user?.pivot.code}}</td>
                      <td>{{user?.pivot.created_at|date:short}}</td>
                      <td>
                        <span class="label label-block label-default"
                          *ngIf="user.pivot.status === 'Pending' || user.pivot.status === 'pending'">{{user.pivot.status}}</span>
                        <span class="label label-block label-primary"
                          *ngIf="user.pivot.status === 'Active' || user.pivot.status === 'active'">{{user.pivot.status}}</span>
                        <span class="label label-block label-success"
                          *ngIf="user.pivot.status === 'Qualified' || user.pivot.status === 'qualified'">{{user.pivot.status}}</span>
                        <span class="label label-block label-warning"
                          *ngIf="user.pivot.status === 'Disqualified' || user.pivot.status === 'disqualified'">{{user.pivot.status}}</span>
                        <span class="label label-block label-danger"
                          *ngIf="user.pivot.status === 'Inactive' || user.pivot.status === 'inactive'">{{user.pivot.status}}</span>
                        <span class="label label-block bg-royal-400"
                          *ngIf="user.pivot.status === 'Won' || user.pivot.status === 'won'">{{user.pivot.status}}</span>
                        <span *ngIf="user.pivot.status === 'Initialized' || user.pivot.status === 'initialized'"
                          class="label label-block bg-royal-400">{{user.pivot.status}}</span>
                      </td>
                      <td class="text-center">
                        <ul class="icons-list">
                          <li class="dropdown">
                            <a href="" class="dropdown-toggle" data-toggle="dropdown">
                              <i class="icon-menu9"></i>
                            </a>

                            <ul class="dropdown-menu dropdown-menu-right">
                              <li>
                                <a href="" (click)="setMember(user)" data-toggle="modal"
                                  data-target="#membership_modal">
                                  <i class="icon-file-pdf"></i>Update</a>
                              </li>

                              <li class="dropdown-submenu dropdown-submenu-left">
                                <a href="#">Change Status</a>
                                <ul class="dropdown-menu">
                                  <li>
                                    <a
                                      (click)="updateMembership(user.pivot.ekub_id,user.pivot.user_id,user?.pivot.code,'active',user?.pivot.branch_id,user?.pivot.remark)">
                                      <i class="icon-shuffle"></i> Active</a>
                                  </li>
                                  <li>
                                    <a
                                      (click)="updateMembership(user?.pivot.ekub_id,user?.pivot.user_id,user?.pivot.code,'pending',user?.pivot.branch_id,user?.pivot.remark)">
                                      <i class="icon-shuffle"></i> Pending</a>
                                  </li>
                                  <li>
                                    <a
                                      (click)="updateMembership(user.pivot.ekub_id,user.pivot.user_id,user?.pivot.code,'qualified',user?.pivot.branch_id,user?.pivot.remark)">
                                      <i class="icon-shuffle"></i> Qualified</a>
                                  </li>
                                  <li>
                                    <a
                                      (click)="updateMembership(user.pivot.ekub_id,user.pivot.user_id,user?.pivot.code,'disqualified',user?.pivot.branch_id,user?.pivot.remark)">
                                      <i class="icon-shuffle"></i> Disqualified</a>
                                  </li>
                                  <li>
                                    <a
                                      (click)="updateMembership(user.pivot.ekub_id,user.pivot.user_id,user?.pivot.code,'won',user?.pivot.branch_id,user?.pivot.remark)">
                                      <i class="icon-shuffle"></i> Won</a>
                                  </li>
                                </ul>
                              </li>
                              <li class="divider"></li>
                              <li>
                                <a *ngIf="user.pivot.status != 'inactive'"
                                  (click)="deactivateMember(user?.pivot.id,'inactive')" class="text-danger">
                                  <i class="bg-danger icon-file-excel"></i><span> Deactivate</span></a>
                                <a *ngIf="user.pivot.status == 'inactive'"
                                  (click)="deactivateMember(user?.pivot.id,'active')" class="text-danger">
                                  <i class="bg-danger icon-file-excel"></i><span> Reactivate</span></a>
                              </li>

                            </ul>
                          </li>
                        </ul>
                      </td>
                    </tr>
                  </tbody>
                </table>

                <div class="row">
                  <div class="text-center">

                    <pagination-controls id="ekubMembers" (pageChange)="pageChanged(currentPage = $event)">
                    </pagination-controls>

                    <br>
                  </div>

                </div>




              </div>
              <div class="col-md-3">

                <!-- Available hours -->
                <div class="panel">
                  <div class="panel-body">

                    <!-- Title -->
                    <div class="category-title h6">
                      <span class="custom-subtitle">Sync Rating</span>
                      <ul class="icons-list">
                        <li><a href="#"><i class="icon-gear"></i></a></li>
                      </ul>
                    </div>
                    <!-- /title -->

                    <!-- User thumbnail -->
                    <div class="thumbnail">
                      <div class="thumb thumb-rounded request-loader text-center" [ngClass]="{'request-load': syncing}">
                        <button [disabled]="syncing" type="button" class="btn btn-circle btn-xl"
                          (click)="sync()">{{syncText}}</button>
                      </div>
                      <br>
                    </div>

                    <!-- /user thumbnail -->

                    <!-- Latest updates -->
                    <div class="sidebar-category">
                      <div class="category-title">
                        <span>Equb Details</span>
                      </div>

                      <div class="category-content">
                        <ul class="media-list">
                          <li class="media">
                            <div class="media-left">
                              <a href="#"
                                class="btn border-primary text-primary btn-flat btn-rounded btn-icon btn-sm"><i
                                  class="icon-calendar"></i></a>
                            </div>

                            <div class="media-body">
                              Code
                              <div class="media-annotation">{{ekub?.ekub_id}}</div>
                            </div>
                          </li>

                          <li class="media">
                            <div class="media-left">
                              <a href="#"
                                class="btn border-warning text-warning btn-flat btn-rounded btn-icon btn-sm"><i
                                  class="icon-cash"></i></a>
                            </div>

                            <div class="media-body">
                              Start Date
                              <div class="media-annotation">{{ekub?.start_date|date:'short'}}</div>
                            </div>
                          </li>

                          <li class="media">
                            <div class="media-left">
                              <a href="#"
                                class="btn border-warning text-warning btn-flat btn-rounded btn-icon btn-sm"><i
                                  class="icon-cash"></i></a>
                            </div>

                            <div class="media-body">
                              Value
                              <div class="media-annotation">{{ekub?.value|number:'1.2-2'}} ETB</div>
                            </div>
                          </li>

                          <li class="media">
                            <div class="media-left">
                              <a href="#" class="btn border-info text-info btn-flat btn-rounded btn-icon btn-sm"><i
                                  class="icon-user-check"></i></a>
                            </div>

                            <div class="media-body">
                              Qualified Members
                              <div class="media-annotation">48</div>
                            </div>
                          </li>

                          <li class="media">
                            <div class="media-left">
                              <a href="#"
                                class="btn border-success text-success btn-flat btn-rounded btn-icon btn-sm"><i
                                  class="icon-user-block"></i></a>
                            </div>

                            <div class="media-body">
                              2
                              <div class="media-annotation">Disqualified Members</div>
                            </div>
                          </li>

                          <li class="media">
                            <div class="media-left">
                              <a href="#"
                                class="btn border-primary text-primary btn-flat btn-rounded btn-icon btn-sm"><i
                                  class="icon-info22"></i></a>
                            </div>

                            <div class="media-body">
                              Status
                              <div class="media-annotation">{{ekub?.status}}</div>
                            </div>
                          </li>
                        </ul>
                      </div>
                    </div>
                    <!-- /latest updates -->


                  </div>
                </div>
                <!-- /available hours -->

              </div>

            </div>

          </div>
        </div>

        <div class="tab-pane has-padding" id="transactions-tab">

          <div class="row">
            <div class="col-md-3 form-group required">
              <span style="float:left" class="control-label">Filter by: </span>
              <select name="status" required [(ngModel)]="filter" (ngModelChange)="getTransactionsFilter(filter)"
                class="form-control">
                <option selected disabled>Status</option>
                <option value="">All</option>
                <option value="&status=pending">Pending</option>
                <option value="&status=confirmed">Confirmed</option>
                <option value="&status=declined">Declined</option>
              </select>
            </div>

            <div class="col-md-3 form-group required">
              <span class="control-label">&nbsp; </span>
            </div>
          </div>

          <table class="table datatable-column-search-inputs">
            <thead>
              <tr>
                <th>Member</th>
                <th>Equb</th>
                <th>Transaction No.</th>
                <th>Date</th>
                <th>Amount</th>
                <th>Date</th>
                <th>Status</th>
                <th class="text-center">Actions</th>
              </tr>
            </thead>
            <tbody>
              <tr
                *ngFor="let transaction of ekubTransactions | paginate: { id: 'ekubTransactions',itemsPerPage: itemsPerPage,currentPage: currentPage,totalItems: totalItems }">
                <td>
                  <div class="media">
                    <span class="media-left">
                      <img *ngIf="!transaction?.user?.data?.avatar" src="assets/img/userm.png" width="40" height="40"
                        class="img-circle img-md" alt="">
                      <img *ngIf="transaction?.user?.data?.avatar"
                        [src]="baseUrl+'assets/'+transaction?.user?.data?.avatar+'/render'" width="40" height="40"
                        class="img-circle img-md" alt="">
                    </span>
                    <div class="media-left">{{transaction?.user?.data?.username}}
                      <div class="text-muted text-size-small">
                        {{transaction.code}}
                      </div>
                    </div>
                  </div>
                </td>
                <td>
                  <div class="media">
                    <div class="media-left">{{transaction?.ekub?.data?.ekub_id}}
                    </div>
                  </div>
                </td>

                <td> {{transaction.transaction_number}} </td>
                <td>
                  <div class="media">
                    <div class="media-left">{{transaction?.ekub?.data?.account?.data?.accronym}}
                      <div class="text-muted text-size-small">
                        {{transaction?.ekub?.data?.account?.data?.account_number}}
                      </div>
                    </div>
                  </div>
                </td>
                <td>{{transaction?.amount|number:'1.2-2'}} ETB</td>
                <td>{{transaction?.transaction_date | date:short}}</td>
                <td>
                  <span class="label label-block label-default"
                    *ngIf="transaction.status === 'Pending' || transaction.status === 'pending'">{{transaction.status}}</span>
                  <span class="label label-block label-danger"
                    *ngIf="transaction.status === 'Declined' || transaction.status === 'declined'">{{transaction.status}}</span>
                  <span class="label label-block label-primary"
                    *ngIf="transaction.status === 'Confirmed' || transaction.status === 'confirmed'">{{transaction.status}}</span>
                </td>
                <td class="text-center">
                  <ul class="icons-list">
                    <li class="dropdown">
                      <a href="" class="dropdown-toggle" data-toggle="dropdown">
                        <i class="icon-menu9"></i>
                      </a>

                      <ul class="dropdown-menu dropdown-menu-right">
                        <li>
                          <a href="" (click)="setMember(user)" data-toggle="modal" data-target="#membership_modal">
                            <i class="icon-file-pdf"></i>Update</a>
                        </li>
                        <li>
                          <a href="">
                            <i class="icon-file-excel"></i>Delete</a>
                        </li>
                        <li class="divider"></li>
                        <li class="dropdown-submenu dropdown-submenu-left">
                          <a href="#">Change Status</a>
                          <ul class="dropdown-menu">

                            <li>
                              <a (click)="changeTrxnStatus(transaction?.id,'pending')">
                                <i class="icon-shuffle"></i> Pending</a>
                            </li>
                            <li>
                              <a (click)="changeTrxnStatus(transaction?.id, 'confirmed')">
                                <i class="icon-shuffle"></i> Confirmed</a>
                            </li>
                            <li>
                              <a (click)="changeTrxnStatus(transaction?.id, 'declined')">
                                <i class="icon-shuffle"></i> Declined</a>
                            </li>

                          </ul>
                        </li>
                      </ul>
                    </li>
                  </ul>
                </td>
              </tr>
            </tbody>
          </table>

          <div class="row">
            <div class="text-center">

              <pagination-controls id="ekubMembers" (pageChange)="pageChanged(currentPage = $event)">
              </pagination-controls>

              <br>
            </div>

          </div>

        </div>

      </div>


    </div>


  </div>
</div>


<!-- <cp-temp></cp-temp> -->



<!-- Membership modal -->
<div id="membership_modal" class="modal fade" tabindex="-1">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <button type="button" class="close" data-dismiss="modal">&times;</button>
        <h5 class="modal-title">Update Equb Member</h5>
      </div>

      <form name="membershipForm" [formGroup]="membershipForm" novalidate>
        <div class="modal-body">
          <div class="row">


            <div class="col-sm-6">
              <div class="form-group">
                <div class="row">

                  <label>&nbsp;</label>
                  <label>Code:</label>
                  <br>
                  <br>
                  <input type="text" placeholder="Code" class="form-control" formControlName="code">
                </div>
              </div>
            </div>
            <div class="col-sm-6">
              <div class="form-group">
                <div class="row">

                  <label>&nbsp;</label>
                  <label>Branch:</label>
                  <ng-select [items]="branches" placeholder="" formControlName="branch" bindValue="id" bindLabel="text"
                    required>
                  </ng-select>
                </div>
              </div>
            </div>

            <div class="col-sm-6">
              <div class="form-group">
                <label>User</label>
                <input type="text" placeholder="User" name="username" readonly class="form-control"
                  formControlName="username">
              </div>
            </div>

            <!--             <div class="col-sm-6">
              <div class="form-group">
                <label>Equb</label>
                <input type="text" placeholder="Equb" readonly class="form-control"
                  [(ngModel)]="selectedMember.username">
              </div>
            </div> -->


            <div class="col-sm-6">
              <div class="form-group">
                <div class="row">

                  <label>&nbsp;</label>
                  <label>Status:</label>
                  <select name="status" required formControlName="status" class="form-control"
                    data-placeholder="Select equb member status">
                    <option selected disabled>Status:</option>
                    <option value="pending">Pending</option>
                    <option value="active">Active</option>
                    <option value="qualified">Qualified</option>
                    <option value="disqualified">Disqualified</option>
                    <option value="won">Won</option>
                  </select>

                </div>
              </div>
            </div>

            <div class="col-sm-12">

              <div class="form-group">
                <div class="row">
                  <label>&nbsp;</label>
                  <label>Remark:</label>
                  <textarea rows="5" cols="5" class="form-control" name="remark" formControlName="remark"
                    placeholder="Remark . . ."></textarea>
                </div>
              </div>
            </div>
          </div>
        </div>



        <div class="modal-footer">
          <button type="button" class="btn btn-link" data-dismiss="modal">Cancel</button>
          <button (click)="updateMembership()" data-dismiss="modal" class="btn bg-brown">Update Member</button>
        </div>

      </form>
    </div>
  </div>

</div>
<!-- /Membership modal -->



<!-- Notification modal -->
<div id="notificationModal" class="modal fade" tabindex="-1">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <button type="button" class="close" data-dismiss="modal">&times;</button>
        <h5 class="modal-title"><span *ngIf="notification?.id">Update</span><span *ngIf="!notification?.id">Add</span>
          Notification</h5>
      </div>
      <hr>
      <form name="notificationForm" [formGroup]="notificationForm" novalidate>
        <div class="modal-body">

          <div class="form-group">
            <div class="row">
              <div class="col-sm-6">
                <span class="control-label">Status: </span>
                <select name="statusFilter" [(ngModel)]="statusFilter" [ngModelOptions]="{standalone: true}"
                  class="form-control" data-placeholder="Select membership status">
                  <option value="">To All</option>
                  <option value="?membership_status=pending">Pending</option>
                  <option value="?membership_status=active">Active</option>
                  <option value="?membership_status=qualified">Qualified</option>
                  <option value="?membership_status=disqualified">Disqualified</option>
                  <option value="?membership_status=won">Won</option>
                  <option value="?membership_status=inactive">Won</option>
                </select>
              </div>

            </div>
          </div>

          <div class="form-group">
            <div class="row">
              <div class="col-sm-12">
                <label>Title</label>
                <input type="text" placeholder="Notification title" class="form-control" formControlName="title">
              </div>
              <div class="col-sm-12">
                <label>&nbsp;</label><br>
                <label>Message:</label>
                <textarea rows="5" cols="5" class="form-control" name="remark" formControlName="content"
                  placeholder="Notification content. . ."></textarea>
              </div>
            </div>
          </div>



          <div class="form-group">
            <div class="row">

              <div class="col-sm-6 required">
                <span class="control-label">Type: </span>
                <select name="type" required formControlName="type" class="form-control"
                  data-placeholder="Select notification type">
                  <option value="info">Info</option>
                  <option value="warning">Warning</option>
                  <option value="danger">Danger</option>
                </select>
                <div class="help-block" *ngIf="type.invalid && (type.dirty || type.touched)">
                  <p class="text-danger">
                    <i class="icon-cancel-circle2 position-left"></i>Notification Type is required.
                  </p>
                </div>
              </div>


            </div>
          </div>

        </div>

        <div class="modal-footer">
          <button type="button" class="btn btn-link" data-dismiss="modal">Cancel</button>
          <button (click)="broadcastNotification()" data-dismiss="modal" class="btn btn-rounded bg-slate-800"><i
              class="icon-add position-left"></i>
            Broadcast Notification</button>
        </div>
      </form>
    </div>
  </div>
</div>
<!-- /Notification modal -->